// extracted by mini-css-extract-plugin
module.exports = {"loading":"applet_loading__2N96l"};